module.exports = __webpack_public_path__ + "img/contact-perringborg.dd5566a0.jpg";